import { ArrayUtil } from './ArrayUtil';

export class RandomGenerator {

    private initSeed: number;

    constructor(public seed: number) {
        this.seed = Math.abs(seed);
        if (this.seed == 0) {
            this.seed = 2147483647;
        }
        this.initSeed = this.seed;
    }

    public reset(): void {
        this.seed = this.initSeed;
    }

    public next(): number {
        this.seed = (this.seed * 16807) % 2147483647;
        return this.seed / 2147483647;
    }

    public nextBetween(min: number, max: number): number {
        if (min > max) {
            let temp: number = max;
            max = min;
            min = temp;
        }
        return min + this.next() * (max - min);
    }

    public nextInt(max: number): number {
        let rand: number = this.next();
        return Math.floor((max + 1) * rand);
    }

    public nextIntBetween(min: number, max: number): number {
        if (min > max) {
            let temp: number = max;
            max = min;
            min = temp;
        }
        return min + this.nextInt(max - min);
    }

    public getArrayRandomElement(array: Array<any>, removeElement: Boolean): any {
        if (array && array.length) {
            let randomIndex: number = this.nextInt(array.length - 1);
            let element: any = array[randomIndex];
            if (removeElement)
                array.splice(randomIndex, 1);
            return element;
        }
        return null;
    }

    public randomizeArray(array: Array<any>): void {
        var len: number = array.length;
        for (let i: number = 0; i < len; ++i) {
            ArrayUtil.swapElements(array, i, this.nextInt(len - 1));
        }
    }

    public generateRandomString(len: number, allowNumbers?: boolean): string {
        let acode: number = String("A").charCodeAt(0);
        let code: string = "";

        if (allowNumbers) {
            let index: number;
            while (code.length < len) {
                // 0-25: alphabet, 26-34: 1-9
                index = this.nextInt(34);
                if (index < 26) {
                    code += String.fromCharCode(acode + index);
                } else {
                    code += index - 25;
                }
            }
        } else {
            while (code.length < len) {
                code += String.fromCharCode(acode + this.nextInt(25));
            }
        }
        return code;
    }
}

export class SystemRandomGenerator extends RandomGenerator {
    constructor() {
        super(1);
    }

    public next(): number {
        return Math.random();
    }
}



// WEBPACK FOOTER //
// ./src/framework/utils/RandomGenerator.ts